export const HIVE_DRAG_HANDLE_WIDGET = 'hive-drag-handle-widget';
